import { createOrGetFetchedState } from '@vista-digital/utilities';
import { Validator } from '@vista-digital/validator';
import { ocapiClient } from '../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../utils/load-data-from-api';
import { logger } from '../../../utils/logger';
import { seatingDomainStore } from '../store';
/**
 * Loads and stores the seat availability preview data for a given showtime.
 */
export const loadSeatAvailabilityPreviewForShowtime = async (showtimeId) => {
    if (!Validator.nonEmptyString(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot load seat availability. Provided showtimeId is invalid.');
    }
    return await loadDataFromApi({
        api: () => ocapiClient.instance.v1.seating.availability.getForShowtime(showtimeId, { preview: true }),
        state: createOrGetFetchedState(seatingDomainStore.data.seatAvailabilityPreviews, showtimeId),
        cacheDuration: getCacheDuration('seatAvailabilityPreviews')
    });
};
//# sourceMappingURL=load-seat-availability-preview-for-showtime.js.map